import React, { memo } from 'react';

import { Block } from '../../components/core';
import { PortfolioContributionContent } from './portfolio-contribution-content';
import { PortfolioContributionHeader } from './portfolio-contribution-header';

import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';
import { SubjectsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/SubjectsErrorWrapper';
import { NoStrategyLevelsSelectedErrorWrapper } from '../../../studio-blocks/components/error-wrappers/NoStrategyLevelsSelectedErrorWrapper';

interface PortfolioContributionBlockProps {
  id: string;
}

export const PortfolioContributionBlock = memo(function InternalPortfolioContributionBlock({
  id,
}: PortfolioContributionBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <PortfolioContributionHeader id={id} />
      </Block.Header>

      {/** TODO: remove SubjectsErrorWrapper being added at the start for Jira VENN-29581, won't be necessary */}
      <Block.Content
        id={id}
        errorWrappers={[
          SubjectsErrorWrapper,
          ...COMMON_ERROR_WRAPPERS,
          MetricsErrorWrapper,
          NoStrategyLevelsSelectedErrorWrapper,
        ]}
      >
        <PortfolioContributionContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
